<!--会议退回查询组件-->
<template>
  <div class="cardtable">
    <v-flex xs12>
      <div class="event-filter">
        <v-flex xs12>
          <v-layout row>
            <v-flex xs10>
              <div class="event-title">{{ this.$t('report.filter') }}</div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-layout row>
          <v-flex xs12 md4>
            <div class="event-filter-title">
              订单号
            </div>
          </v-flex>
          <v-flex xs12 md4>
            <div class="event-filter-title">
              {{ this.$t('report.supplyname') }}
            </div>
          </v-flex>
          <v-flex xs12 md4>
            <div class="event-filter-title">
              {{ this.$t('report.materialname') }}
            </div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.purchaseOrder"
              :value="filter.purchaseOrder"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.vendorName"
              :value="filter.vendorName"
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              required
              class="filter-interval event-filter-content"
              v-model="filter.materialName"
              :value="filter.materialName"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md8>
            <div class="event-filter-title">
              {{ this.$t('report.receiptdate') }}
            </div>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12 md8>
            <v-layout row>
              <v-flex xs12 md5.5>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  class="filter-interval event-filter-content"
                >
                  <v-text-field
                    readonly
                    slot="activator"
                    v-model="filter.startDate"
                    append-icon="mdi-grid"
                    class="event-filter-content"
                  ></v-text-field>
                  <v-date-picker
                    v-model="filter.startDate"
                    no-title
                    style="color:black!important"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xsl2 md1>
                ~
              </v-flex>
              <v-flex xs12 md5.5>
                <v-menu
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                  class="filter-interval event-filter-content"
                >
                  <v-text-field
                    readonly
                    slot="activator"
                    v-model="filter.endDate"
                    append-icon="mdi-grid"
                    class="event-filter-content"
                  ></v-text-field>
                  <v-date-picker
                    v-model="filter.endDate"
                    no-title
                    style="color:black!important"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-flex xs1>
            <v-btn
              @click="clearfilter()"
              color="#1cade4"
              class="Btn_add"
              depressed
            >
              {{ this.$t('report.clearfilter') }}</v-btn
            >
          </v-flex>
          <v-flex xs1>
            <v-btn
              depressed
              color="#1cade4"
              class="Btn_add"
              @click="getsearchdata()"
            >
              {{ this.$t('report.apply') }}</v-btn
            >
          </v-flex>
          <v-flex xs1>
            <v-btn
              @click="reportExport()"
              color="#1cade4"
              class="Btn_add"
              depressed
            >
              {{ this.$t('common.export') }}</v-btn
            >
          </v-flex>
        </v-layout>
      </div>
    </v-flex>
    <v-flex xs12 style="background-color:white!important;">
      <div class="allevent-content">
        <div class="table-header">
          <v-layout row>
            <v-flex xs4>
              <v-layout row>
                <v-flex xs2>
                  <div>收货</div>
                  <div>单号</div>
                </v-flex>
                <v-flex xs2>
                  <div>收货</div>
                  <div>日期</div>
                </v-flex>
                <v-flex xs2>
                  <span>物料号</span>
                </v-flex>
                <v-flex xs3>
                  <div>物料</div>
                  <div>名称</div>
                </v-flex>
                <v-flex xs2>
                  <div>供应商</div>
                  <div>代码</div>
                </v-flex>
                <v-flex xs3>
                  <div>供应商</div>
                  <div>名称</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout row>
                <v-flex xs1>
                  <div>生产</div>
                  <div>厂家</div>
                </v-flex>
                <v-flex xs3>
                  <div>生产</div>
                  <div>地址</div>
                </v-flex>
                <v-flex xs3>
                  <span>批号</span>
                </v-flex>
                <v-flex xs2>
                  <div>生产</div>
                  <div>日期</div>
                </v-flex>
                <v-flex xs2>
                  <div>有效</div>
                  <div>期至</div>
                </v-flex>
                <v-flex xs2>
                  <div>到货剩余</div>
                  <div>有效期</div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout row>
                <v-flex xs1>
                  <div>计划</div>
                  <div>数量</div>
                </v-flex>
                <v-flex xs1>
                  <div>总标</div>
                  <div>签数</div>
                </v-flex>
                <v-flex xs1>
                  <div>有效</div>
                  <div>标签</div>
                </v-flex>
                <v-flex xs1>
                  <div>差异</div>
                  <div>标签</div>
                </v-flex>
                <v-flex xs2>
                  <div>有效</div>
                  <div>通过率</div>
                </v-flex>
                <v-flex xs3>
                  <span>收货人</span>
                </v-flex>
                <v-flex xs3>
                  <span>复核人</span>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>

        <div class="table-row" v-for="(item, key) in report.items" :key="key">
          <v-layout row>
            <v-flex xs4>
              <v-layout row>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.receiptNo }}
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.receiptDate }}
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.materialCode }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div class=" table-cell">
                    <div style="padding-left:4px">
                      {{ item.materialName }}
                    </div>
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.vendorCode }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div class=" table-cell">
                    {{ item.vendorName }}
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout row>
                <v-flex xs1 shrink>
                  <div class=" table-cell">
                    {{ item.manufacturerName }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div class=" table-cell">
                    {{ item.manufacturerAddress }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div class=" table-cell">
                    <div style="padding-left:4px">
                      {{ item.batchNo }}
                    </div>
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.produceDate }}
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.expireDate }}
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.remainingPeriod }}
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout row>
                <v-flex xs1>
                  <div class=" table-cell">
                    {{ item.totalPlanNo }}
                  </div>
                </v-flex>
                <v-flex xs1>
                  <div class=" table-cell">
                    {{ item.totalNo }}
                  </div>
                </v-flex>
                <v-flex xs1>
                  <div class=" table-cell">
                    {{ item.totalValidNo }}
                  </div>
                </v-flex>
                <v-flex xs1>
                  <div class=" table-cell">
                    {{ item.totalDiffNo }}
                  </div>
                </v-flex>
                <v-flex xs2>
                  <div class=" table-cell">
                    {{ item.validRatio }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div class=" table-cell">
                    {{ item.receiverName }}
                  </div>
                </v-flex>
                <v-flex xs3>
                  <div class=" table-cell">
                    {{ item.reviewerName }}
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </div>
        <div v-if="report.items.length == 0" class="partipant-module-MESSAGE">
          {{ this.$t('emptymsg') }}
        </div>
        <v-pagination
          v-if="length > 0"
          v-model="page"
          :length="length"
          :total-visible="7"
        ></v-pagination>
      </div>
    </v-flex>
    <core-dataloading ref="dataload"></core-dataloading>
    <core-confirm ref="myConfirm"></core-confirm>
  </div>
</template>
<style>
.table-row > div {
  text-align: left;
}
</style>
<script>
import { mapState } from 'vuex'
import CoreDataloading from '@/components/core/dataloading.vue'
import CoreConfirm from '@/components/core/confirm.vue'
import { reportQquery, reportExport } from '@/request/api'
export default {
  components: {
    CoreDataloading,
    CoreConfirm
  },
  data: () => ({
    search: '',
    filter: {
      purchaseOrder: '',
      vendorName: '',
      materialName: '',
      startDate: null,
      endDate: null
    },
    length: 0,
    page: 1,
    pagesize: 8,
    showsearch: false,
    hclass: 'table-cell'
  }),
  mounted: function() {
    this.$nextTick(() => {
      this.getdatas()
    })
    this.base.confirmDialog = this.$refs.myConfirm
  },
  watch: {
    page() {
      this.getdatas()
    },
    pagesize() {
      this.getdatas()
    }
  },
  computed: {
    ...mapState({
      report: state => state.report,
      base: state => state.base
    })
  },
  methods: {
    getsearchdata() {
      this.page = 1
      this.getdatas()
    },
    getdatas() {
      var _this = this
      let param = {
        purchaseOrder: _this.filter.purchaseOrder,
        vendorName: _this.filter.vendorName,
        materialName: _this.filter.materialName,
        startDate: _this.filter.startDate,
        endDate: _this.filter.endDate,
        pageIndex: this.page,
        pageSize: this.pagesize,
        t: new Date().getTime()
      }
      this.base.eventdom
        .CommonEventApi(
          reportQquery,
          param,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在查询数据'
        )
        .then(res => {
          _this.length =
            res.totalCount % _this.pagesize == 0
              ? res.totalCount / _this.pagesize
              : parseInt(res.totalCount / _this.pagesize) + 1
          _this.report.items = res.items
        })
    },
    reportExport() {
      this.base.eventdom
        .CommonEventApi(
          reportExport,
          this.filter,
          this.$refs.dataload,
          this.$refs.myConfirm,
          '正在导出数据'
        )
        .then(data => {
          let blob = new Blob([data], {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })

          let currentdate = new Date()
          let file_name = 'Report' + currentdate.getTime()
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // for IE

            window.navigator.msSaveOrOpenBlob(blob, file_name + '.xlsx')
          } else {
            let link = document.createElement('a')
            link.download = file_name
            link.href = window.URL.createObjectURL(blob)
            link.click()
            //释放内存
            window.URL.revokeObjectURL(link.href)
          }
        })
    },
    clearfilter() {
      this.filter = {
        purchaseOrder: '',
        vendorName: '',
        materialName: '',
        startDate: null,
        endDate: null
      }
    }
  }
}
</script>
